/**
 * 前台菜单 Tab。
 *
 * 分类只归属「经典菜单」，标识固定为 classic —— 后台新增/编辑分类时不允许修改，
 * 避免同一批分类散落到不同 tab 导致小程序菜单分裂。
 */
export enum MenuTab {
  Classic = 'classic',
}

export const MENU_TAB_LABELS: Record<MenuTab, string> = {
  [MenuTab.Classic]: '经典菜单',
}
